import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneCallEnded = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M.917 10.817l-.322-.322a.7.7 0 0 1 0-.99l.99-.99c4.648-4.647 12.182-4.647 16.83 0l.99.99a.7.7 0 0 1 0 .99l-1.98 1.98a.7.7 0 0 1-.99 0l-1.98-1.98c-.277-.277-.495-.802-.495-1.188V7.189a10.54 10.54 0 0 0-7.92 0v2.098c0 .396-.218.92-.49 1.193l-1.99 1.99a.7.7 0 0 1-.985-.005L.917 10.807v.01z" }));
const ForwardRef = forwardRef(SvgPhoneCallEnded);
export default ForwardRef;
